"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Pagination = props => {
  const {
    className = '',
    others,
    ofLabel = 'of',
    itemsPerPage = 10,
    items = [],
    onChangePage = () => {}
  } = props;
  const classes = (0, _index.default)();
  const [page, setPage] = _react.default.useState(0);
  const disableRipple = {
    disableRipple: true
  };
  const getPaginatedItems = pageParam => {
    const currentPage = pageParam + 1;
    const start = currentPage * itemsPerPage - itemsPerPage;
    const newItems = [...items];
    return {
      page,
      paginatedItems: newItems.splice(start, itemsPerPage)
    };
  };
  const paginatedCallback = (0, _react.useCallback)(getPaginatedItems);
  const handleChangePage = (event, newPage) => {
    const params = paginatedCallback(newPage);
    setPage(newPage);
    onChangePage(params);
  };
  (0, _react.useEffect)(() => {
    setPage(0);
    const params = paginatedCallback(0);
    onChangePage(params);
    // eslint-disable-next-line
  }, [items]);
  return /*#__PURE__*/_react.default.createElement(_TablePagination.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className),
    classes: classes,
    nextIconButtonProps: disableRipple,
    backIconButtonProps: disableRipple,
    labelDisplayedRows: _ref => {
      let {
        from,
        to,
        count
      } = _ref;
      return "".concat(from, " - ").concat(to, " ").concat(ofLabel, " ").concat(count);
    },
    component: "div",
    count: items.length,
    page: page,
    onChangePage: handleChangePage,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: []
  }, others));
};
var _default = exports.default = Pagination;